import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import axios from 'axios';
import useApi from '../../api/useApi';
import '../../scrollbar.css';

function PrinterDetail({ printerId, handleClose, orgId }) {
  const [{ isLoading, isError, data }, getData] = useApi();
  const [zplFilesRes, getZplFiles] = useApi();
  const [state2, getPrintedLabels] = useApi();
  const [state3, postData] = useApi();
  const [zplFileRes, getZplFile] = useApi();

  const [printerDetail, setPrinterDetail] = useState([]);
  const [formData, setFormData] = useState({ role: '', isActive: '', userId: '' });
  const [printerPopup, setPrinterPopup] = useState(false);
  const [zplFiles, setZplFiles] = useState([]);
  const [selectedZpl, selectZpl] = useState('');
  const [labels, setLabels] = useState([]);
  const [changeLabels, setChangeLabels] = useState({});
  const [showPreview, setShowPreview] = useState(false);
  const [previewImage, setPreviewImage] = useState(false);

  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));

  const user = sessionStorage.getItem('user');

  if (!user) {
    location.href = '/';
  }

  useEffect(() => {
    getData(`/device/${printerId}/printer`, 'GET');
    getPrintedLabels(`/device/${printerId}/printedLabels`, 'GET');
    getZplFiles(`/zplFiles`, 'GET');
  }, []);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setPrinterDetail(data.project);
    }
    if (isError) {
    }
  }, [isLoading, isError, data]);

  useEffect(() => {
    if (selectedZpl) {
      getZplFile(`/organization/${orgId}/zplFile?name=${selectedZpl}`, 'GET');
    }
  }, [selectedZpl]);

  useEffect(() => {
    if (!zplFileRes.isLoading && !zplFileRes.isError && zplFileRes.data) {
      const labelList = [];
      zplFileRes.data.file.split('<').forEach((z) => {
        if (z.indexOf('>') !== -1) labelList.push(z.split('>')[0]);
      });
      setLabels(labelList);
    }
  }, [zplFileRes.isLoading, zplFileRes.isError, zplFileRes.data]);

  const getProjectId = (zpl) => {
    const _project = zplFiles.filter((item) => item.name === zpl);
    if (_project.length > 0) {
      return _project[0].Project.id;
    }
  };

  useEffect(() => {
    if (!zplFilesRes.isLoading && !zplFilesRes.isError && zplFilesRes.data) {
      setZplFiles(zplFilesRes.data.zplFiles);
    }
  }, [zplFilesRes]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedZpl) return;
    let x = zplFileRes?.data?.file.replace(/(?:\\[rn]|[\r\n]+)+/g, '');
    const attributes = {};
    const str_repl = {};
    Object.keys(changeLabels).forEach((key) => {
      attributes[key] = changeLabels[key];
      // x = x.replace(`<${key}>`, changeLabels[key]);
      console.log(`<${key}>`);
      str_repl[`<${key}>`] = changeLabels[key];
    });
    console.log(str_repl);
    const body = {
      printerId,
      attributes,
      payload: { templatestring: x, str_repl },
      zplFile: selectedZpl !== 'default' ? getProjectId(selectedZpl) : 'default',
    };
    // console.log(body);
    postData(`/device/${printerId}/printLabel`, 'POST', body);
  };

  useEffect(() => {
    if (!state3.isLoading && !state3.isError && state3.data) {
      handleClosePrint();
      getData(`/device/${printerId}/printer`, 'GET');
    }
    if (state3.isError) {
      handleClosePrint();
    }
  }, [state3.isLoading, state3.isError, state3.data]);

  const handleClosePrint = () => {
    setPrinterPopup(false);
    selectZpl(null);
    setLabels([]);
  };

  const getTimeoffset = (ts) => {
    const _date = new Date(ts);
    return moment(_date).fromNow();
  };

  const fetchImage = (zpl) => {
    const _selectedZpl = zplFiles.filter((item) => item.name === selectedZpl)[0];
    console.log(_selectedZpl);
    const x = new FormData();
    const blob = new Blob([zpl], { type: 'text/plain' });
    const file = new File([blob], 'foo.zpl');
    x.append('file', file);
    axios({
      method: 'POST',
      url: `https://api.labelary.com/v1/printers/${_selectedZpl.dpmm}dpmm/labels/${_selectedZpl.width}x${_selectedZpl.height}/${_selectedZpl.index}`,
      data: x,
      responseType: 'blob',
    })
      .then((data) => {
        if (data) {
          const reader = new FileReader();
          reader.readAsDataURL(data.data);
          reader.onloadend = () => {
            const base64data = reader.result;
            setPreviewImage(base64data);
          };
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const searchData = () => {
    getData(`/organization/${orgId}/search?type=printedLabel&searchItem=${formData.q}`, 'GET');
  };

  const previewFile = (e) => {
    e.preventDefault();
    let x = zplFileRes?.data?.file;
    const attributes = {};
    Object.keys(changeLabels).forEach((key) => {
      attributes[key] = changeLabels[key];
      x = x.replace(`<${key}>`, changeLabels[key]);
    });
    fetchImage(x);
    setShowPreview(true);
  };

  return (
    <>
      {printerPopup && (
        <div
          className="flex justify-center items-center h-full w-full fixed top-0 left-0 devices_back"
          style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
        >
          <div className="bg-white w-1/3 pt-1 relative rounded-2xl mobile_toggle">
            <div className="flex justify-between border-b px-5 py-4">
              <p className="font-bold text-sm text-textBlue1">Print Label</p>

              <img
                src="assets/img/Close.svg"
                className="h-3 mt-1 cursor-pointer z-50"
                alt=""
                onClick={() => {
                  handleClosePrint();
                }}
              />
            </div>

            <form className="mt-4 mb-2 flex flex-wrap" onSubmit={handleSubmit} autoComplete="off">
              <div className="w-full relative flex flex-col items-center px-5">
                <div className="px-4 py-2 focus:outline-none inputLabelText">
                  <select
                    className="border-none w-full focus:outline-none text-sm  text-parameter border "
                    autoComplete="off"
                    value={selectedZpl}
                    onChange={(e) => {
                      selectZpl(e.target.value);
                    }}
                  >
                    <option className="fy-4" value="">
                      Select ZPL
                    </option>
                    {zplFiles.map((item) => (
                      <option key={item?.id}>{item?.name}</option>
                    ))}
                  </select>
                </div>
              </div>

              {labels.map((item) => (
                <div className="w-full mt-4 relative flex flex-col items-center px-5">
                  <input
                    type="text"
                    placeholder={item}
                    autoComplete="off"
                    required
                    className="inputLabelText px-4 py-2 focus:outline-none"
                    onChange={(e) => {
                      setChangeLabels({
                        ...changeLabels,
                        [item]: e.target.value,
                      });
                    }}
                  />
                </div>
              ))}

              <div className="w-full flex mt-10 mb-2 relative ml-auto">
                {state3.isLoading ? (
                  <div className="flex justify-between w-full px-5">
                    <img src="assets/img/loader.svg" className="w-14 ml-auto" alt="" />
                  </div>
                ) : (
                  <div className="flex justify-between w-full px-5 text-xs">
                    <button
                      onClick={previewFile}
                      className={`rounded-3xl w-24 focus:outline-none py-2 text-xs text-white bg-primary mr-auto ${
                        zplFileRes.isLoading || !selectedZpl ? 'cursor-not-allowed opacity-40' : 'cursor-pointer'
                      }`}
                      style={{ background: '#16406D' }}
                      disabled={zplFileRes.isLoading || !selectedZpl}
                    >
                      Preview
                    </button>
                    <button
                      onClick={handleClosePrint}
                      className="rounded-3xl border focus:outline-none w-32 h-10 mr-3 ml-auto cursor-pointer "
                      // style={{ border: '1px solid #16406D' }}
                    >
                      Cancel
                    </button>

                    <button
                      type="submit"
                      className={`rounded-3xl w-32 focus:outline-none py-2 text-xs text-white bg-primary ${
                        zplFileRes.isLoading || !selectedZpl ? 'cursor-not-allowed opacity-40' : 'cursor-pointer'
                      }`}
                      style={{ background: '#16406D' }}
                      disabled={zplFileRes.isLoading || !selectedZpl}
                    >
                      {zplFileRes.isLoading ? 'Loading...' : 'Submit'}
                    </button>
                  </div>
                )}
              </div>
              {/* <div className="flex w-1/2 items-center  my-3.5 relative">
            <label className="block text-parameter w-1/3 text-sm" />
            {state2.isLoading || isLoading ? (
              <img src="assets/img/loader.svg" className="absolute w-16 right-36 mx-auto" alt="" />
            ) : (
              <input
                type="submit"
                className="rounded-lg focus:outline-none w-1/2 h-10 text-textBlue1 cursor-pointer "
                style={{ background: '#16406D33', border: '1px solid #16406D' }}
              />
            )}
          </div> */}
            </form>
          </div>
        </div>
      )}

      {showPreview && (
        <div
          className="flex justify-center items-center h-full w-full fixed top-0 left-0 devices_back"
          style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
        >
          <div className="bg-white w-1/3 pt-1 relative rounded-2xl mobile_toggle">
            <div className="flex justify-between border-b px-5 py-4">
              <p className="font-bold text-sm text-textBlue1">Preview</p>

              <img
                src="assets/img/Close.svg"
                className="h-3 mt-1 cursor-pointer z-50"
                alt=""
                onClick={() => {
                  setShowPreview(false);
                  setPreviewImage(null);
                }}
              />
            </div>

            <div className="border m-6">
              <img src={`${previewImage}`} className="w-full" style={{ height: '77vh' }} alt="" />
            </div>
          </div>
        </div>
      )}

      <div className="mt-10 bg-white mx-auto px-3 project_allign rules_ui" style={{ height: '90vh' }}>
        <div className="z-50" style={{ height: '21vh', paddingBottom: '4vh' }}>
          <div
            className="lg:flex block sm:block justify-between text-center lg:text-left w-tableWidth m-auto  overflow-auto"
            style={{ paddingTop: '4vh' }}
          >
            <span className="text-titleColor font-bold text-base mobile_icon9"> Labels printed by {printerId}</span>

            <div className="block lg:flex mt-1 lg:mt-0 overflow-auto ">
              <div
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs cursor-pointer font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white button_mobile31 overflow-auto"
                onClick={() => {
                  handleClose(false);
                }}
              >
                Back
              </div>
              <div
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs cursor-pointer font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white button_mobile31 overflow-auto mx-3"
                onClick={() => {
                  setPrinterPopup(true);
                }}
              >
                Print Label
              </div>

              <button
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white button_mobile2 "
                onClick={() => {
                  // downloadExcel('tblData');
                }}
              >
                Report
                <img src="assets/img/download.svg" className="h-3 ml-2 transform rotate-180" alt="" />
              </button>

              <div className="mt-1 lg:mt-0 w-full text-xs lg:w-max border bg-transparent px-3 py-1.5 ml-3 flex justify-between items-center rounded-3xl button_search2">
                <input
                  type="text"
                  placeholder="Search"
                  autoComplete="off"
                  className="text-textBox bg-transparent focus:outline-none button_search2"
                  // value={formData.q}
                  name="q"
                  onChange={handleInputChange}
                  style={{ borderColor: '#e6e6e6' }}
                  onKeyDown={(e) => {
                    if (e.which === 13) searchData();
                  }}
                />
                <img src="assets/img/Search.png" className="h-4 ml-2 button_search3" alt="" />
              </div>
            </div>
          </div>
        </div>

        <div className="tbl mobile_view1" style={{ minWidth: '700px' }}>
          <div className="bg-white w-tableWidth m-auto mb-3">
            <div className="bg-white w-full flex border" style={{ borderColor: '#e6e6e6' }}>
              <div className="px-8 py-2 flex w-full relative bg-primary text-white items-center resp_rule">
                <div className="py-2 text-xs font-semibold w-3/12">LABEL</div>
                <div className="py-2 text-xs font-semibold w-3/12">ZPL FILE</div>
                <div className="py-2 text-xs font-semibold w-3/12">STATE</div>
                <div className="py-2 text-xs font-semibold w-3/12">PRINTED BY</div>
                <div className="py-2 text-xs font-semibold w-3/12">STATUS</div>
                <div className="py-2 text-xs font-semibold w-3/12">LAST MODIFIED</div>
              </div>
            </div>
            {!state2.isLoading ? (
              <div className="hideScroll" style={{ overflowY: 'scroll', height: '70vh' }}>
                <div className="w-full">
                  {state2.data &&
                    state2.data.printedLabels &&
                    state2.data.printedLabels.length > 0 &&
                    state2.data.printedLabels.map((item) => (
                      <div
                        className="my-2 px-8 py-1 xl:py-1.5 items-center flex
                      relative hover:border-indigo-200 focus-within:border-indigo-200 focus:bg-rowSelect hover:bg-rowSelect"
                        style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                      >
                        <div className="text-role font-semibold text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-3/12">
                          {item?.labelId}
                        </div>
                        <div className="text-role font-semibold text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-3/12">
                          {item?.Project?.projectName}
                        </div>
                        <div className="text-role font-semibold text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-3/12">
                          {item?.state}
                        </div>
                        <div className="text-role font-semibold text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-3/12">
                          {item?.creator?.userName}
                        </div>
                        <div
                          className={`text-${
                            item?.isActive ? 'green-600' : 'red-600'
                          } font-semibold text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-3/12`}
                        >
                          {item?.isActive ? 'Active' : 'Inactive'}
                        </div>
                        <div className="text-role font-semibold text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-3/12">
                          {getTimeoffset(item?.updatedAt)}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            ) : (
              <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default PrinterDetail;
